var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "fans-page": true, "iphone-x": _vm.isIPhoneX } },
    [
      _c("transparent-header", {
        attrs: { titleColor: "#1A1A1A", color: "#fff", customOpacity: 1 },
      }),
      _vm.loadComplete && _vm.data
        ? [
            _c(
              "div",
              { staticClass: "header" },
              [
                _c("van-notice-bar", {
                  attrs: {
                    "left-icon": "volume-o",
                    scrollable: false,
                    text: "粉丝重新下一笔支付金额≥1元的订单即可激活",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "section" }, [
              _c("div", { staticClass: "module-wrap clearfix" }, [
                _c(
                  "div",
                  { staticClass: "module-con" },
                  [
                    _c(
                      "van-list",
                      {
                        attrs: {
                          finished: _vm.tab.finished,
                          "error-text": "请求失败，点击重新加载",
                        },
                        on: {
                          load: function ($event) {
                            return _vm.getList(_vm.tab)
                          },
                        },
                        model: {
                          value: _vm.tab.loading,
                          callback: function ($$v) {
                            _vm.$set(_vm.tab, "loading", $$v)
                          },
                          expression: "tab.loading",
                        },
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "fan-list clearfix" },
                          _vm._l(_vm.tab.dataItems, function (item, index) {
                            return _c(
                              "li",
                              { key: index, staticClass: "fan-item" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "fan-pic" },
                                  [
                                    _c("van-image", {
                                      attrs: {
                                        "lazy-load": "",
                                        src: item.uPic,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "loading",
                                            fn: function () {
                                              return [
                                                _c("van-loading", {
                                                  attrs: {
                                                    type: "spinner",
                                                    size: "20",
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "fan-con" }, [
                                  _c("div", { staticClass: "fan-info" }, [
                                    _c("div", { staticClass: "fan-nic-con" }, [
                                      _c("div", { staticClass: "fan-nic" }, [
                                        _vm._v(_vm._s(item.uNic)),
                                      ]),
                                      _c(
                                        "span",
                                        { staticClass: "fan-status" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getMapProp(
                                                _vm.fansStateMap,
                                                item.fansState,
                                                "text"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "register-time" },
                                      [
                                        _vm._v(
                                          "注册时间：" + _vm._s(item.uCtimeStr)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "fan-bar" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "invite-btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toInvite(item)
                                          },
                                        },
                                      },
                                      [_vm._v("去邀请出单")]
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _c("template", { slot: "finished" }, [
                          !_vm.tab.dataItems.length
                            ? _c("div", { staticClass: "no-data-wrap" }, [
                                _c("div", { staticClass: "no-data" }, [
                                  _vm._v("暂无数据"),
                                ]),
                              ])
                            : _c(
                                "div",
                                { staticClass: "van-list__finished-text" },
                                [_vm._v("亲，到底了哦~")]
                              ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("scroll-top"),
          ]
        : _vm._e(),
      _c("loading", { ref: "$loading" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }